import { buildDataQuery, buildGetAllEntities } from './entity';
import { buildRelationSearchQuery } from './relations';
import { adminSearch } from './search';

export default {
  DATA_QUERY: buildDataQuery,
  GET_ALL_ENTITIES: buildGetAllEntities,
  RELATION_SEARCH_QUERY: buildRelationSearchQuery,
  ADMIN_SEARCH: adminSearch
};
